export class Campaign {
  constructor(myWaves, enemyWaves, backgroundImage, goal) {
    // goal : kill/defeat all VS kill X troops VS hold X time
    this.myWaves = myWaves;
    this.enemyWaves = enemyWaves;
    this.goal = goal;
    this.backgroundImage = backgroundImage;
  }
}